import { Bars3BottomLeftIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { CompanyLogo } from '@/components/UI/CompanyLogo';
import { accountSelector } from '../../../store';

export default function SidebarNavHeader({
  isFullNavHidden,
  navToggleHandler,
}: {
  isFullNavHidden?: boolean;
  navToggleHandler?: () => void;
}) {
  const { data: currentClientAccount } = useSelector(accountSelector);

  return (
    <>
      {!isFullNavHidden && <CompanyLogo imageUrl={currentClientAccount.companyLogoUrl} fallbackClassName='h-10' />}
      {isFullNavHidden && (
        <span className='flex text-center justify-center items-center w-full' onClick={navToggleHandler}>
          {isFullNavHidden && (
            <Bars3BottomLeftIcon className='h-8 w-8 hover:text-primaryColor-normal cursor-pointer transition duration-300' />
          )}
        </span>
      )}
    </>
  );
}
